import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useLazyLoad, useReduxSelector, applicationSelector } from '@applyboard/ab-common';
import { documentRequirementSelector, receiptRequirementSelector, questionRequirementSelector, disclaimerRequirementSelector, paymentRequirementSelector } from "../selectors/requirements";
import { getApplicationVerifiedDocumentsAction, getApplicationRequirementsAction } from "../../../../api/jsonapi";
import applicationStateChangesSelector from "../selectors/applicationStateChanges";
export default function useStudentRecords() {
  // get local data
  var documents = useReduxSelector(documentRequirementSelector);
  var receipts = useReduxSelector(receiptRequirementSelector);
  var questions = useReduxSelector(questionRequirementSelector);
  var disclaimers = useReduxSelector(disclaimerRequirementSelector);
  var payments = useReduxSelector(paymentRequirementSelector);
  var application = useReduxSelector(applicationSelector);
  var statusChanges = useReduxSelector(applicationStateChangesSelector);

  // request data
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useLazyLoad = useLazyLoad(getApplicationRequirementsAction, function (perform) {
      return perform({
        application_id: application && application.applicationId,
        include: ['application_additional_attachments', 'application_external_links', 'attachments', 'application_questions'].join(',')
      });
    }),
    _useLazyLoad2 = _slicedToArray(_useLazyLoad, 2),
    _ = _useLazyLoad2[0],
    request = _useLazyLoad2[1];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useLazyLoad3 = useLazyLoad(getApplicationVerifiedDocumentsAction, {
      id: application && application.applicationId
    }),
    _useLazyLoad4 = _slicedToArray(_useLazyLoad3, 2),
    __ = _useLazyLoad4[0],
    verifiedDocumentsRequest = _useLazyLoad4[1];
  return {
    documents: documents || [],
    receipts: receipts || [],
    questions: questions || [],
    disclaimers: disclaimers || [],
    payments: payments || [],
    statusChanges: statusChanges || [],
    isLoading: request.isLoading || verifiedDocumentsRequest.isLoading,
    application: application
  };
}